import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<g stroke="none"><path fill-rule="evenodd" d="M12 25c-5 0-5.98-6.135-6-16.764C5.998 7 6.894 6 7.999 6H22c1.106 0 2.002 1.001 2 2.236 0 .27-.002.538-.003.803.636.05 1.303.162 1.897.417.586.251 1.137.651 1.53 1.277.39.62.576 1.379.576 2.267 0 1.653-.416 3.002-1.485 3.893-.81.675-1.868.975-3.05 1.07C22.763 22.513 21.22 25 18 25h-6zm11.713-9.075c.72-.102 1.201-.301 1.522-.568.43-.36.765-1.01.765-2.357 0-.612-.127-.977-.268-1.202-.138-.218-.337-.38-.626-.504-.321-.138-.704-.211-1.137-.25-.039 1.784-.117 3.415-.256 4.88z" clip-rule="evenodd"></path><path d="M6 27a1 1 0 0 1 1-1h16a1 1 0 1 1 0 2H7a1 1 0 0 1-1-1z"></path></g>';
export var MugSVG = function MugSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
MugSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(MugSVG);